<template>
    <div class="ix-formbuilder-component-summary-content" v-if="currentField.label">

        <div class="formbuilder-component boxed" v-if="displayMode == 'readable' || displayMode == 'fillable'">
            <p class="formbuilder-title" :style="{'color' : currentField.font_color}" :class="[currentField.font_weight && currentField.font_weight == 'bold' ? 'bold' : '']">
                  {{ currentField.label }}
            </p>
        </div>

        <div v-if="displayMode == 'summary'" class="ix-formbuilder-component-summary-info">
            <div class="ix-formbuilder-component-summary-handle">
                <span class="ix-drag-icon handle-line"></span>
            </div>
            <div class="ix-formbuilder-component-summary-icon" data-toggle="tooltip" data-placement="top" title="Paragraphe">
                <div class="ix-formbuilder-icon">
                    <i class="far fa-paragraph"></i>
                </div>
            </div>
            <div class="ix-formbuilder-component-summary-content">
                <span class="ix-formbuilder-component-summary-label" v-html="nl2br(currentField.label)"></span>
                <ul class="ix-formbuilder-component-summary-options">
                    <li>Taille : 
                        <span v-if="currentField.font_size == 'small'">Petit</span>
                        <span v-if="currentField.font_size == 'normal'">Normal</span>
                        <span v-if="currentField.font_size == 'large'">Grand</span>
                    </li>
                    <li>Style : 
                        <span v-if="currentField.font_weight == 'normal'">Normal</span>
                        <span v-if="currentField.font_weight == 'bold'">Gras</span>
                    </li>
                </ul>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "ParagraphComponent",
        props: ['currentField','showIcon', 'displayMode'],
    }
</script>
